.atm_c8_1ij03t3.atm_c8_1ij03t3{font-size:var(--font-size-styles-alias-inline-expr0);}
.atm_le_ftgil2.atm_le_ftgil2{padding-bottom:8px;}
.atm_9s_1txwivl{display:flex;}
.atm_40_okh77k{border-bottom:1px solid transparent;}
.atm_cg5yt7_1mtxhqg:hover,.atm_cg5yt7_1mtxhqg:focus-within{border-bottom:1px solid var(--editable-text-div-inline-expr0);}
.atm_40_1mtxhqg{border-bottom:1px solid var(--editable-text-div-inline-expr0);}
.atm_e2_1wbj5dn{height:var(--editable-text-input-inline-expr0);}
.atm_l8_zikty{padding:0px 16px;}
.atm_1vc6k0m_kb7nvz:hover .edit-icon,.atm_1vc6k0m_kb7nvz:focus-within .edit-icon{opacity:1;}
.atm_k4_kb7nvz{opacity:1;}
.atm_k4_idpfg4{opacity:0;}
.atm_2d_1j28jx2.atm_2d_1j28jx2{background-color:transparent;}
.atm_cs_1fw03zg.atm_cs_1fw03zg{font-weight:700;}
.atm_3f_glywfm{border:none;}
.atm_kd_glywfm{outline:none;}
.atm_vy_1osqo2v{width:100%;}
.atm_lk_ftgil2.atm_lk_ftgil2{padding-left:8px;}
.atm_n1gy25_qgx6rq::placeholder{color:#6F7780;}
.atm_r3_1e5hqsa{text-align:left;}
.atm_gi_idpfg4{margin:0;}
.atm_7l_qgx6rq{color:#6F7780;}
.atm_9s_11p5wf0{display:grid;}
.atm_dz_1ghlemp.atm_dz_1ghlemp{grid-template-columns:1fr auto;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_174zlj6_n7od8j:disabled{cursor:unset;}
.atm_gz_ftgil2.atm_gz_ftgil2{margin-left:8px;}
.atm_h0_ftgil2.atm_h0_ftgil2{margin-right:8px;}
.atm_h3_ftgil2.atm_h3_ftgil2{margin-top:8px;}
.atm_7l_9ztun4{color:#DD3131;}
